import api from '../../../../services/api';

// Printer Categories Actions
export const FETCH_PRINTER_CATEGORIES_START = 'FETCH_PRINTER_CATEGORIES_START';
export const FETCH_PRINTER_CATEGORIES_SUCCESS = 'FETCH_PRINTER_CATEGORIES_SUCCESS';
export const FETCH_PRINTER_CATEGORIES_ERROR = 'FETCH_PRINTER_CATEGORIES_ERROR';

export const CREATE_PRINTER_CATEGORY_START = 'CREATE_PRINTER_CATEGORY_START';
export const CREATE_PRINTER_CATEGORY_SUCCESS = 'CREATE_PRINTER_CATEGORY_SUCCESS';
export const CREATE_PRINTER_CATEGORY_ERROR = 'CREATE_PRINTER_CATEGORY_ERROR';

export const UPDATE_PRINTER_CATEGORY_START = 'UPDATE_PRINTER_CATEGORY_START';
export const UPDATE_PRINTER_CATEGORY_SUCCESS = 'UPDATE_PRINTER_CATEGORY_SUCCESS';
export const UPDATE_PRINTER_CATEGORY_ERROR = 'UPDATE_PRINTER_CATEGORY_ERROR';

export const DELETE_PRINTER_CATEGORY_START = 'DELETE_PRINTER_CATEGORY_START';
export const DELETE_PRINTER_CATEGORY_SUCCESS = 'DELETE_PRINTER_CATEGORY_SUCCESS';
export const DELETE_PRINTER_CATEGORY_ERROR = 'DELETE_PRINTER_CATEGORY_ERROR';

// New filter actions
export const SET_PRINTER_FILTERS = 'SET_PRINTER_FILTERS';
export const CLEAR_PRINTER_FILTERS = 'CLEAR_PRINTER_FILTERS';

// Fetch all printers with optional filters
export const fetchPrinterCategories = (filters = {}) => async (dispatch) => {
    dispatch({ type: FETCH_PRINTER_CATEGORIES_START });
    try {
        // Build query parameters for backend filtering
        const params = new URLSearchParams();
        
        // Add pagination params
        if (filters.page) params.append('page', filters.page);
        if (filters.pageSize) params.append('pageSize', filters.pageSize);
        
        // Add filter params
        if (filters.searchText) {
            params.append('search', filters.searchText);
        }
        if (filters.statusFilter && filters.statusFilter !== 'all') {
            const isActive = filters.statusFilter === 'active';
            params.append('isActive', isActive);
        }
        if (filters.codeFilter && filters.codeFilter !== 'all') {
            params.append('code', filters.codeFilter);
        }
        if (filters.sortBy) {
            params.append('sortBy', filters.sortBy);
        }
        if (filters.sortOrder) {
            params.append('sortOrder', filters.sortOrder);
        }
        
        const response = await api.get(`/printers?${params.toString()}`);
        console.log('API Response:', response.data); // Debug log
        
        // Handle the API response structure: { data: { rows: [...], count: ..., pagination: ... } }
        const printers = response.data?.data?.rows || [];
        const pagination = response.data?.data?.pagination || {};
        
        dispatch({ 
            type: FETCH_PRINTER_CATEGORIES_SUCCESS, 
            payload: {
                categories: printers,
                pagination,
                total: response.data?.data?.count || 0
            }
        });
        return { success: true, data: printers };
    } catch (error) {
        console.error('Error fetching printers:', error);
        dispatch({ 
            type: FETCH_PRINTER_CATEGORIES_ERROR, 
            payload: 'Không thể tải danh sách nhà in' 
        });
        return { success: false, error: error.message };
    }
};

// Create a new printer
export const createPrinterCategory = (printerData) => async (dispatch) => {
    dispatch({ type: CREATE_PRINTER_CATEGORY_START });
    try {
        const response = await api.post('/printers', printerData);
        const newPrinter = response.data?.data || response.data;
        dispatch({ 
            type: CREATE_PRINTER_CATEGORY_SUCCESS, 
            payload: newPrinter 
        });
        return { success: true, data: newPrinter };
    } catch (error) {
        console.error('Error creating printer:', error);
        dispatch({ 
            type: CREATE_PRINTER_CATEGORY_ERROR, 
            payload: 'Không thể tạo nhà in mới' 
        });
        return { success: false, error: error.message };
    }
};

// Update a printer
export const updatePrinterCategory = (id, printerData) => async (dispatch) => {
    dispatch({ type: UPDATE_PRINTER_CATEGORY_START });
    try {
        const response = await api.put(`/printers/${id}`, printerData);
        const updatedPrinter = response.data?.data || response.data;
        dispatch({ 
            type: UPDATE_PRINTER_CATEGORY_SUCCESS, 
            payload: { id, ...updatedPrinter } 
        });
        return { success: true, data: updatedPrinter };
    } catch (error) {
        console.error('Error updating printer:', error);
        dispatch({ 
            type: UPDATE_PRINTER_CATEGORY_ERROR, 
            payload: 'Không thể cập nhật nhà in' 
        });
        return { success: false, error: error.message };
    }
};

// Delete a printer
export const deletePrinterCategory = (id) => async (dispatch) => {
    dispatch({ type: DELETE_PRINTER_CATEGORY_START });
    try {
        await api.delete(`/printers/${id}`);
        dispatch({ 
            type: DELETE_PRINTER_CATEGORY_SUCCESS, 
            payload: id 
        });
        return { success: true };
    } catch (error) {
        console.error('Error deleting printer:', error);
        dispatch({ 
            type: DELETE_PRINTER_CATEGORY_ERROR, 
            payload: 'Không thể xóa nhà in' 
        });
        return { success: false, error: error.message };
    }
};

// Update printers status (bulk operation)
export const updatePrinterCategoriesStatus = (printerIds, isActive) => async (dispatch) => {
    dispatch({ type: UPDATE_PRINTER_CATEGORY_START });
    try {
        const response = await api.put('/printers/status/batch', {
            printerIds,
            isActive
        });
        
        // Refresh printers list after bulk update
        dispatch(fetchPrinterCategories());
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error updating printers status:', error);
        dispatch({ 
            type: UPDATE_PRINTER_CATEGORY_ERROR, 
            payload: 'Không thể cập nhật trạng thái nhà in' 
        });
        return { success: false, error: error.message };
    }
};

// Fetch available codes for filter dropdown
export const fetchAvailableCodes = () => async (dispatch) => {
    try {
        const response = await api.get('/printers/codes');
        return { success: true, data: response.data?.data?.codes || [] };
    } catch (error) {
        console.error('Error fetching available codes:', error);
        return { success: false, error: error.message };
    }
};

// Auto-suggest search
export const searchCategoriesSuggestions = (searchTerm) => async (dispatch) => {
    try {
        if (!searchTerm || searchTerm.trim().length < 2) {
            return { success: true, data: [] };
        }
        
        const response = await api.get(`/printers/search?q=${encodeURIComponent(searchTerm)}&limit=5`);
        return { success: true, data: response.data?.data?.suggestions || [] };
    } catch (error) {
        console.error('Error fetching search suggestions:', error);
        return { success: false, error: error.message };
    }
};

// Apply filters and fetch data from backend
export const applyFilters = (filters) => async (dispatch) => {
    // Update filters in state
    dispatch({ type: SET_PRINTER_FILTERS, payload: filters });
    
    // Fetch data with new filters
    return dispatch(fetchPrinterCategories(filters));
};

// Clear all filters
export const clearFilters = () => async (dispatch) => {
    dispatch({ type: CLEAR_PRINTER_FILTERS });
    
    // Fetch data without filters
    return dispatch(fetchPrinterCategories());
};

// Search printers by text
export const searchCategories = (searchText) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.printerCategories?.filters || {};
    const newFilters = { ...currentFilters, searchText, page: 1 };
    
    return dispatch(applyFilters(newFilters));
};

// Filter by status
export const filterByStatus = (statusFilter) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.printerCategories?.filters || {};
    const newFilters = { ...currentFilters, statusFilter, page: 1 };
    
    return dispatch(applyFilters(newFilters));
};

// Filter by code
export const filterByCode = (codeFilter) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.printerCategories?.filters || {};
    const newFilters = { ...currentFilters, codeFilter, page: 1 };
    
    return dispatch(applyFilters(newFilters));
};

// Change pagination
export const changePagination = (page, pageSize) => async (dispatch, getState) => {
    const currentFilters = getState().categoryManagement?.printerCategories?.filters || {};
    const newFilters = { ...currentFilters, page, pageSize };
    
    return dispatch(applyFilters(newFilters));
};